import { useEffect, useRef, useState } from 'react'

export function useRecorder(deviceId: string) {
  const [isRecording, setIsRecording] = useState(false)

  const chunks = useRef<Blob[]>([])

  const [recordingStartTime, setRecordingStartTime] = useState(Date.now())
  const [recordedMediaDuration, setRecordedMediaDuration] = useState<number>()

  const recorder = useRef<MediaRecorder | null>(null)
  useEffect(() => {
    const promise = (async () => {
      // If the device id is changed during recording, it's an error
      if (isRecording) throw new Error('DeviceId is changed during a recording')

      const stream = await navigator.mediaDevices.getUserMedia({
        audio: { deviceId },
      })

      const rc = new MediaRecorder(stream)
      rc.ondataavailable = (ev) => {
        chunks.current?.push(ev.data)
      }

      // Reset the states when the device is changed
      recorder.current = rc
      chunks.current = []

      return stream
    })()

    return () => {
      promise.then((stream) =>
        stream.getAudioTracks().forEach((track) => track.stop()),
      )
    }
  }, [deviceId])

  return {
    start: () => {
      if (isRecording) throw new Error('Recorder is already recording')

      chunks.current = []
      setIsRecording(true)
      setRecordingStartTime(Date.now())
      recorder.current?.start()
    },
    stop: () => {
      if (!isRecording) throw new Error('Recorder is not recording at all')

      setIsRecording(false)
      recorder.current?.stop()

      setRecordedMediaDuration(Date.now() - recordingStartTime)
    },
    getUrl: () => {
      const blob = new Blob(chunks.current, { type: 'audio/ogg; codecs=opus' })
      return URL.createObjectURL(blob)
    },
    isRecording,
    recordedMediaDuration,
    recordingStartTime,
  }
}
